import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  datePicker: {
    width: '100%'
  }
}));
